import { Link } from "react-router-dom";
import styles from "../styles.module.css";

export const ProgramCard = ({
	title,
	formLink = "",
	handleCurrentLink,
	applicationForm
}) => {
	return (
		<div className={styles.programCardContainer}>
			<p className={styles.programTitle}>{title}</p>
			<p className={`mt-3 ${styles.programSubtitle}`}>
				Please select a link applicable to you from the list below
			</p>
			<div className={`${styles.cardLinks}`}>
				<Link to={() => handleCurrentLink(applicationForm)}>
					Generate Invoice
				</Link>
				<Link
					to={{
						pathname: formLink,
						state: applicationForm
					}}
				>
					Application Form
				</Link>
			</div>
		</div>
	);
};
